<template>
    <v-app
        id="app"
        :class="[{ 'global-alert': showGlobalAlert }, { 'user-is-not-loggedin': !loggedIn }]"
    >
        <AppNavigation
            v-if="loggedIn"
            :class="showGlobalAlert ? 'global-alert' : ''"
        />
        <template v-if="sidebar">
            <release-notes-popup
                v-if="loggedIn"
                :dialog="displayReleaseNotes"
                @closeReleaseNotes="displayReleaseNotes = false"
                @newVersion="displayReleaseNotes = true"
            >
                <AppInfo @displayReleaseNotes="displayReleaseNotes = true" />

            </release-notes-popup>
        </template>

        <transition name="fade">
            <suspense>
                <image-editor v-if="$store.state?.mediaLibrary?.editImage && loggedIn" />
            </suspense>
        </transition>

        <global-alert @displayAlert="showAlert($event)" />

        <v-toolbar
            v-if="loggedIn"
            color="white"
            light
            app
            floating
            :elevation="4"
        >
            <v-app-bar-nav-icon @click.stop="openNavigation()" :class="['sidebar-toggle', sidebar ? 'sidebar-open' : 'sidebar-closed']"/>

            <v-spacer/>

            <v-toolbar-items>
                <router-link
                    class="profile"
                    to="/profile"
                >
                    <v-img
                        src="https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png"
                        class="profile__image"
                        height="25"
                        width="25"
                    />

                    <span class="profile__name">{{ loggedInAs }}</span>
                </router-link>
            </v-toolbar-items>
            <v-btn
                type="button"
                class="logout dark"
                v-on:click="logout()"
            >Logout</v-btn>
        </v-toolbar>

        <v-main>


            <v-progress-linear
                v-show="isLoading"
                :indeterminate="true"
                color="accent"
            />
            <v-container
                fluid
                fill-height
                pt-0
                px-0
            >
                <v-layout
                    justify-start
                    align-start
                >
                    <main
                        class="main"
                        v-if="loggedIn ||
                            $route.path === '/login' ||
                            $route.path === '/login-forgot-password' ||
                            $route.path === '/login-set-password' ||
                            $route.path === '/login-reset-password'
                        "
                        :class="showGlobalAlert ? 'main--alert' : ''"
                    >
                        <v-breadcrumbs
                            :items="routes"
                            divider="/"
                        >
                            <template v-slot:title="{ item }">
                                <router-link
                                    :to="item.path"
                                    class="breadcrumb"
                                >{{
                                    item.name
                                }}</router-link>
                            </template>
                        </v-breadcrumbs>

                        <router-view/>

                    </main>
                </v-layout>

            </v-container>

        </v-main>
    </v-app>
</template>

<script>

import GlobalAlert from "@/components/GlobalAlert/GlobalAlert.vue"
import AppNavigation from "@/components/AppNavigation.vue";
import AppInfo from "@/components/AppInfo.vue";
import ReleaseNotesPopup from "@/components/ReleaseNotes/ReleaseNotesPopup.vue";
import ImageEditor from "@/components/Media/V2/ImageEditor.vue";
import { defineComponent } from "vue"
// import { isAuthenticated } from "./middlewares/checkAuth.ts"
export default defineComponent({
    name: "App",
    components: {
        AppNavigation,
        AppInfo,
        ImageEditor,
        ReleaseNotesPopup,
        GlobalAlert,
    },

    data() {
        return {
            loggedInAs: "",
            displayReleaseNotes: false,
            modules: null,
            showGlobalAlert: false,
            authorised: false,
        };
    },
    computed: {
        sidebar() {
            return this.$store.state.sidebar;
        },

        isLoading() {
            return this.$store.state.loading;
        },
        routes() {
            return this.$route.matched ? this.$route.matched : []
        },
        userDetails() {
            return this.$store.state.user
        },
        loggedIn() {
            return this.$store.state.user.email.length > 0 && this.$isLoggedIn()
        }
    },


    created() {
        console.log(`${process.env.VUE_APP_CLUB_ID}`);
        this.modules = require("./config/features/" +
            process.env.VUE_APP_CLUB_ID +
            "/modules.js");
    },

    mounted() {
        const freshworksID = process.env.VUE_APP_FRESHWORKS_WIDGET_ID || "80000010022"

        window.fwSettings = {
            widget_id: freshworksID
        }

        void (function() {
            if (typeof window.FreshworksWidget !== "function") {
                const n = function() {
                    n.q.push(arguments)
                }
                n.q = []
                window.FreshworksWidget = n
            }
        })()

        // Create freshworks script
        const script = document.createElement("script")
        script.type = "text/javascript"
        script.src = `https://euc-widget.freshworks.com/widgets/${freshworksID}.js`
        script.async = true
        script.defer = true
        document.head.appendChild(script)

        // Upon initial mount we check the authentication state

        if (this.$getAuthenticatedUser() != null) {
            // console.log("Access Check", "user authenticated");
            this.$getCurrentUserAttributes().subscribe(
                (userData) => {
                    this.$store.commit("saveUserDetails", {
                        firstName: userData.given_name,
                        lastName: userData.family_name,
                        email: userData.email,
                    });

                    this.loggedInAs = userData.email;

                },
                (err) => {

                    if (err.code === "PasswordResetRequiredException") {
                        this.redirectToPasswordReset();
                    } else {
                        this.redirectToLogin();
                    }
                }
            );
        } else {
            this.$store.commit("removeUserDetails")
        }

        //check if authorized
        this.$getCurrentUserGroups().subscribe((userGroups) => {
            if (userGroups.includes("Administrator") || userGroups.includes("Admin") || userGroups.includes("News")) {
                this.authorised = true
            } else {
                this.authorised = false
            }
        },
        (err) => {
            this.authorised = false
            console.log(err)
        });
    },

    methods: {
        openNavigation() {
            if (this.sidebar) {
                this.$store.commit("closeSidebar");
            } else {
                this.$store.commit("openSidebar");
            }
        },

        redirectToPasswordReset() {
            if (this.$route.path !== "/login-reset-password") {
                this.$router.push("/login-reset-password");
            }
        },
        async redirectToLogin() {
            if (
                window.location.pathname != "/login" &&
                window.location.pathname != "/login-set-password" &&
                window.location.pathname != "/login-reset-password" &&
                window.location.pathname != "/login-forgot-password"
            ) {
                console.log("redirect to logiiiiin");
                await this.$router.push("/login")
            }
        },

        async logout() {
            this.$signOut();
            this.$store.commit("removeUserDetails")
            await this.$router.push("/login");
        },

        showAlert(val) {
            this.showGlobalAlert = val;
        },
    },
})
</script>

<style lang="scss">
.v-progress-linear {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    margin: 0;
}

.fade-enter-active {
    animation: fade-in 0.5s;
}

.fade-leave-active {
    animation: fade-out 0.5s;
}

@keyframes fade-in {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes fade-out {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}
</style>


<style lang="scss" scoped>
.main {
    position: relative;
    flex-grow: 1;
    overflow: hidden;
    padding-top: 6px;
    max-width: 100vw;
    margin-top: 64px;

    &--alert {
        padding-top: 40px !important;
    }
}

.sidebar-toggle {
    transition: padding-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar-open {
    padding-left: 316px;
}

.sidebar-closed {
    padding-left: 0;
}

.v-toolbar--floating {
    @media screen and (min-width: 1200px) {
        position: fixed;
        z-index: 1003;
        padding-right: 24px;
    }
}

.v-breadcrumbs {
    padding: 25px 0 10px var(--body-gutter);
    background-color: #fff;
}

.breadcrumb {
    color: #354052;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }

    &--active {
        color: green;
    }
}

.profile {
    display: flex;
    flex-direction: row;
    justify-items: center;
    align-items: center;

    &__image {
        margin-right: 8px;
        border-radius: 50%;
    }

    &__name {
        font-size: 12px;
        margin-right: 12px;
    }
}

.v-btn.logout {
    margin-right: 40px;
}

.global-alert {
    top: 50px !important;
}

.v-container {
    padding: 0;
}

.user-is-not-loggedin {
    .main {
        margin-top: 0;
    }

    .main-body {
        height: calc(100vh - 60px);
    }
}
</style>
